import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { SoundConfig } from "./SoundConfig";
import { INolimitAudioPlayer } from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import { NolimitHowl } from "@nolimitcity/slot-audio/bin/NolimitHowl";
import { gsap } from "gsap";
import { ArrayHelper } from "../../../core/utils/ArrayHelper";
import { Helper } from "../../../core/utils/Helper";


export class SoundManager {

    private static currentBigWin: string = "";

    private static currentAmbientLoop: string = "";

    private static standardVolume = 1;
    private static deadVolume = 0.35;
    private static PanningForStop: number[] = [-0.2, -0.1, 0, 0.1, 0.2]; // -1 == Left, 1 == Right

    public static get soundPlayer(): INolimitAudioPlayer {
        return <INolimitAudioPlayer>SlotGame.sound;
    }

    public static playReelStop(reelID: number, isQuick:boolean = false): void {
        const soundName: string = SoundConfig.REELS_DEFAULT_BOUNCE[0];
        const sound: NolimitHowl | undefined = this.soundPlayer.fetchSoundPlayer(soundName)
        if (sound) sound.player.stereo(isQuick ? 0 : this.PanningForStop[reelID]);

        this.playSoundEffect(soundName,undefined,isQuick)
    }

    public static setDeadSpinVolume(val: boolean) {
        this.standardVolume = val ? this.deadVolume : 1;
    }

    public static isLoaded():boolean{
        return !!this.soundPlayer.fetchSoundPlayer(SoundConfig.GAME_INTRO_START);
    }

    public static playIntro(tl:gsap.core.Timeline):void {
        const introSound = this.soundPlayer.playTrack({
            name: SoundConfig.GAME_INTRO_START,
        })!;
        
        const startPos = introSound.player.seek() as number;
        introSound!.player.once("play", () => {
            introSound?.seek(tl.time() + startPos)
        })
        introSound!.player.once("end", () => {
            introSound!.player.stop();
        })
    }

    public static playSoundEffect(name: string, repeat?: number, once?:boolean): NolimitHowl | undefined {
        if(!name) return;
        if(once) this.stopSoundEffect(name);
        return this.soundPlayer.playTrack({
            name: name,
            repeat: repeat,
            volume: this.standardVolume
        });
    }

    public static playSoundSkipEffect(name: string, skipReplace:string, skipped:boolean, once?:boolean): NolimitHowl | undefined {
        if(!name) return;
        if(once) this.stopSoundEffect(name);
        return this.soundPlayer.playTrack({
            name: skipped ? skipReplace : name,
            volume: this.standardVolume
        });
    }

    public static playBigWin(lvl: number): void {
        
        const nextBigWinSound: string = SoundConfig.bigWinLoop(lvl);

        this.soundPlayer.stopTrack(this.currentBigWin);
        this.soundPlayer.playTrack({ name: nextBigWinSound});

        this.currentBigWin = nextBigWinSound;
    }

    public static fadeBigWin(durr:number): void {
        this.soundPlayer.fadeTrack({ name: this.currentBigWin, from: 1, to: 0, duration: durr });
    }

    public static stopBigWin(): void {
        this.soundPlayer.stopTrack(this.currentBigWin);
        this.currentBigWin = "";
    }

    public static PlayAmbience(ambientName:string,fadeMS?:number):void{

        let player = this.soundPlayer.fetchSoundPlayer(this.currentAmbientLoop);
        if(player && player.isPlaying){
            this.stopSoundEffect(this.currentAmbientLoop, fadeMS? fadeMS : undefined);
        }else{
            this.soundPlayer.stopTrack(this.currentAmbientLoop)
        }

        this.soundPlayer.playTrack({ name: ambientName, volume: fadeMS ? 0 : 1 });

        if (fadeMS) this.fadeSound(ambientName, fadeMS, 1, 0)

        this.currentAmbientLoop = ambientName;
    }

    public static FadeAmbience(to:number,duration:number):void{
        this.fadeSound(this.currentAmbientLoop, duration, to);
    }

    public static stopAmbience():void{
        this.stopSoundEffect(this.currentAmbientLoop);
        this.currentAmbientLoop = "";
    }

    public static OnEndFS(isSuper: boolean, wasGood: boolean): void {
    }

    public static StopAllSounds(): void {
        if (this.soundPlayer.allPlayers()[0]) // Loaded
            this.soundPlayer.allPlayers().forEach(p => { p.stop() });
    }

    public static stopSoundEffect(name: string, fadeDurr?:number):  NolimitHowl | undefined {
        if(fadeDurr != undefined){
            this.fadeSound(name,fadeDurr,0)?.player.once("fade", () => {
                this.soundPlayer.stopTrack(name);
            });
        }
        else
            return this.soundPlayer.stopTrack(name);
    }

    public static fadeSound(name: string, duration: number, to:number, from?:number):  NolimitHowl | undefined {
        return this.soundPlayer.fadeTrack({
            name: name,
            duration: duration,
            from: from,
            to: to
        });
    }
}